<template>
<!--  <div class="dashboard">
    <el-row :gutter="20">
      <el-statistic
          group-separator=","
          :precision="2"
          :value="value2"
          :title="title"
      />
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="16">
        <el-card>
          <div slot="header">
            <span>设备数据趋势</span>
          </div>
          <div class="chart-container">
            <div id="dataTrendChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            <span>设备分布</span>
          </div>
          <div class="chart-container">
            <div id="deviceDistributionChart" style="width: 100%; height: 300px;"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>

  </div>-->
  <div style="display: flex;flex-direction: column; flex: 1; justify-content: center; align-items: center ;height: 100%">
    <h1 style="text-align: center">欢迎使用 物联网平台</h1>
  </div>

</template>

<script>
import {statisticsInfo} from "@/api/dashboard";

export default {
  name: 'Dashboard',
  data() {
    return {
      info : {}
    }
  },
  mounted() {
    //this.fetchDashboardInfo()
    //this.initCharts()
  },
  methods: {
    async fetchDashboardInfo() {
      const res = await statisticsInfo()
      this.info = res.result || {}
    },
    initCharts() {
      // 数据趋势图
      const trendChart = this.$echarts.init(document.getElementById('dataTrendChart'))
      const trendOption = {
        title: {
          text: '设备数据24小时趋势'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['温度', '湿度', '能耗']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['00:00', '03:00', '06:00', '09:00', '12:00', '15:00', '18:00', '21:00']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '温度',
            type: 'line',
            data: [18, 17, 16, 20, 24, 26, 25, 22]
          },
          {
            name: '湿度',
            type: 'line',
            data: [60, 62, 65, 58, 55, 52, 54, 58]
          },
          {
            name: '能耗',
            type: 'line',
            data: [3.2, 2.8, 2.5, 3.8, 5.2, 5.8, 4.5, 3.6]
          }
        ]
      }
      trendChart.setOption(trendOption)

      // 设备分布图
      const distributionChart = this.$echarts.init(document.getElementById('deviceDistributionChart'))
      const distributionOption = {
        title: {
          text: '设备类型分布',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '设备类型',
            type: 'pie',
            radius: '70%',
            data: [
              { value: 45, name: '温度传感器' },
              { value: 30, name: '湿度传感器' },
              { value: 25, name: '智能开关' },
              { value: 18, name: '烟雾报警器' },
              { value: 38, name: '其他设备' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      distributionChart.setOption(distributionOption)

      // 响应窗口大小变化
      window.addEventListener('resize', () => {
        trendChart.resize()
        distributionChart.resize()
      })
    }
  }
}
</script>

<style scoped>
.stats-container {
  padding: 10px 0;
}

.stat-card {
  height: 100%;
  display: flex;
  overflow: hidden;
}

.stat-content {
  flex: 1;
  padding: 15px;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  color: #666;
  font-size: 14px;
}

.stat-icon {
  width: 60px;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #909399;
}

.stat-icon.online {
  color: #42b983;
  background-color: #f0f9eb;
}

.stat-icon.offline {
  color: #f56c6c;
  background-color: #fef0f0;
}

.stat-icon.alert {
  color: #e6a23c;
  background-color: #fdf6ec;
}

.chart-container {
  padding: 10px 0;
}
</style>
